export const accessHours = {
  monday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  tuesday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  wednesday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  thursday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  friday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  saturday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  },
  sunday: {
    open: "6:00am",
    close: "10:00pm",
    enabled: true
  }
};

export const officeHours = {
  monday: {
    open: "9:00am",
    close: "5:30pm",
    enabled: true
  },
  tuesday: {
    open: "9:00am",
    close: "5:30pm",
    enabled: true
  },
  wednesday: {
    open: "9:00am",
    close: "5:30pm",
    enabled: true
  },
  thursday: {
    open: "9:00am",
    close: "5:30pm",
    enabled: true
  },
  friday: {
    open: "9:00am",
    close: "5:30pm",
    enabled: true
  },
  saturday: {
    open: "9:00am",
    close: "4:00pm",
    enabled: true
  },
  sunday: {
    open: "9:00am",
    close: "4:00pm",
    enabled: false
  }
};
